import { PageController } from '@client/components/_core/layout/PageController';
import { DocumentLibrary } from '@client/components/_shared/documents/DocumentLibrary';
import { INCIDENT_STATUSES_KEYS } from '@shared/constants';
import { createFileRoute } from '@tanstack/react-router';
import { incidentFormStore } from '../store';

export const Route = createFileRoute('/console/$orgId/compliance/incidents/details/$id/library')({
    component: IncidentLibraryTab,
});

function IncidentLibraryTab() {
    const incident = incidentFormStore.use.formData();

    return (
        <PageController route={Route}>
            <DocumentLibrary
                entity="incident"
                entityId={incident.id}
                disableUploading={incident.status === INCIDENT_STATUSES_KEYS.closed}
                shouldIncludeRelatedEntities
            />
        </PageController>
    );
}
